// 'use client';

// import React, { useEffect, useState } from 'react';
// import { useLocation, useNavigate, Link } from 'react-router-dom';
// import { useGetOrderByIdQuery } from '@/features/api/paymentApi'; // Adjust to your actual path
// import { Loader2 } from 'lucide-react';
// import { toast } from 'sonner';

// const PaymentStatus = () => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   // Check for both 'orderId' and 'merchantOrderId'
//   const searchParams = new URLSearchParams(location.search);
//   const orderId = searchParams.get('orderId') || searchParams.get('merchantOrderId');

//   // Fetch order details with RTK Query and polling
//   const { data: order, isLoading, isError, error } = useGetOrderByIdQuery(orderId, {
//     skip: !orderId,
//     pollingInterval: 5000,
//   });

//   const [status, setStatus] = useState(null);

//   // Update status whenever order changes
//   useEffect(() => {
//     if (order) {
//       setStatus(order.status?.toUpperCase() || 'PENDING');
//     }
//   }, [order]);

//   // Show toast if API fails
//   useEffect(() => {
//     if (isError && error) {
//       toast.error(error?.data?.message || 'Failed to fetch order details');
//     }
//   }, [isError, error]);

//   // Retry payment for failed orders
//   const retryPayment = () => {
//     if (order?.courseId && order?.productName && order?.amount) {
//       navigate(
//         `/checkout?courseId=${order.courseId}&courseName=${order.productName}&price=${order.amount}`
//       );
//     } else {
//       navigate('/courses'); // fallback
//     }
//   };

//   // Handle missing orderId
//   if (!orderId) {
//     return (
//       <div className="max-w-md mx-auto p-6 text-center mt-20 bg-yellow-50 rounded shadow">
//         <h1 className="text-2xl font-bold text-yellow-700 mb-4">Invalid Request</h1>
//         <p className="text-lg text-yellow-800 mb-6">
//           Missing order reference. Please check your payment email or try again.
//         </p>
//         <Link
//           to="/courses"
//           className="inline-block bg-yellow-600 text-white px-6 py-3 rounded hover:bg-yellow-700 transition"
//         >
//           Back to Courses
//         </Link>
//       </div>
//     );
//   }

//   // Loading state
//   if (isLoading) {
//     return (
//       <div className="flex justify-center items-center h-screen">
//         <Loader2 className="h-6 w-6 animate-spin text-blue-600" />
//         <span className="ml-2 text-blue-700">Fetching order details...</span>
//       </div>
//     );
//   }

//   // Error or no order
//   if (isError || !order) {
//     return (
//       <div className="max-w-md mx-auto p-6 text-center mt-20 bg-red-50 rounded shadow">
//         <h1 className="text-2xl font-bold text-red-700 mb-4">Error</h1>
//         <p className="text-lg text-red-800 mb-6">
//           Could not fetch your order details. Please contact support.
//         </p>
//         <Link
//           to="/courses"
//           className="inline-block bg-red-700 text-white px-6 py-3 rounded hover:bg-red-800 transition"
//         >
//           Back to Courses
//         </Link>
//       </div>
//     );
//   }

//   // Render different statuses
//   switch (status) {
//     case 'SUCCESS':
//       return (
//         <StatusCard
//           title="Payment Successful!"
//           bg="bg-green-50"
//           textColor="text-green-700"
//           amountLabel="Amount Paid"
//           buttonColor="bg-green-700"
//           order={order}
//         />
//       );
//     case 'PENDING':
//       return (
//         <StatusCard
//           title="Payment Pending"
//           bg="bg-yellow-50"
//           textColor="text-yellow-700"
//           amountLabel="Amount"
//           buttonColor="bg-yellow-600"
//           order={order}
//           pending={true}
//         />
//       );
//     case 'FAILED':
//     default:
//       return (
//         <StatusCard
//           title="Payment Failed"
//           bg="bg-red-50"
//           textColor="text-red-700"
//           amountLabel="Amount Attempted"
//           buttonColor="bg-red-700"
//           order={order}
//           retryPayment={retryPayment}
//         />
//       );
//   }
// };

// // Reusable Status Card
// const StatusCard = ({
//   title,
//   bg,
//   textColor,
//   amountLabel,
//   buttonColor,
//   order,
//   retryPayment,
//   pending,
// }) => {
//   return (
//     <div
//       className={`max-w-md mx-auto p-6 text-center mt-20 rounded shadow ${bg}`}
//       aria-live="polite"
//     >
//       <h1 className={`text-3xl font-bold mb-4 ${textColor}`}>{title}</h1>
//       <p className={`text-lg mb-6 ${textColor}`}>
//         {pending
//           ? 'Your payment is in progress. We are checking every few seconds...'
//           : 'Thank you. Your order has been processed.'}
//       </p>

//       <div className={`text-left ${textColor} mb-4`}>
//         <p>
//           <strong>Course:</strong> {order.productName || 'Unknown'}
//         </p>
//         <p>
//           <strong>{amountLabel}:</strong> ₹{order.amount?.toFixed(2)}
//         </p>
//         <p>
//           <strong>Transaction ID:</strong> {order.transactionId || order.id}
//         </p>
//       </div>

//       {retryPayment ? (
//         <button
//           onClick={retryPayment}
//           className={`px-6 py-3 rounded text-white hover:opacity-90 transition ${buttonColor}`}
//         >
//           Retry Payment
//         </button>
//       ) : (
//         <Link
//           to="/courses"
//           className={`inline-block px-6 py-3 rounded text-white hover:opacity-90 transition ${buttonColor}`}
//         >
//           Back to Courses
//         </Link>
//       )}
//     </div>
//   );
// };

// export default PaymentStatus;

"use client";

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useGetOrderByIdQuery } from "@/features/api/paymentApi";
import { useEnrollCourseMutation } from "@/features/api/courseApi"; 
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

const PaymentStatus = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const orderId = searchParams.get("orderId") || searchParams.get("merchantOrderId");

  const { data: order, isLoading, isError, error } = useGetOrderByIdQuery(orderId, {
    skip: !orderId,
    pollingInterval: 5000,
  });

  const [status, setStatus] = useState(null);
  const [enrolled, setEnrolled] = useState(false);
  const [enrollCourse] = useEnrollCourseMutation();

  useEffect(() => {
    if (order) setStatus(order.status?.toUpperCase() || "PENDING");
  }, [order]);

  useEffect(() => {
    if (isError && error) {
      toast.error(error?.data?.message || "Failed to fetch order details");
    }
  }, [isError, error]);

  // ✅ Auto-enroll only if productType is COURSE
  useEffect(() => {
    const enrollIfCourse = async () => {
      if (status === "SUCCESS" && order?.productType === "COURSE" && order?.courseId && !enrolled) {
        try {
          await enrollCourse({ courseId: order.courseId }).unwrap();
          setEnrolled(true);
          toast.success("🎉 Enrollment successful!");
          navigate(`/courses/${order.courseId}/learn`, { replace: true });
        } catch (err) {
          console.error("Enrollment error:", err);
          toast.error("Payment succeeded but enrollment failed. Please contact support.");
        }
      }
    };
    enrollIfCourse();
  }, [status, order, enrolled, enrollCourse, navigate]);

  const getBackPath = () => {
    if (!order) return "/";
    if (order.productType === "COURSE") return "/courses";
    if (order.productType === "ONLINE_PAYMENT") return "/online-payment";
    return "/";
  };

  const retryPayment = () => {
    if (!order) return navigate(getBackPath());

    if (order.productType === "COURSE" && order.courseId) {
      navigate(
        `/checkout?courseId=${order.courseId}&courseName=${order.productName}&price=${order.amount}&productType=COURSE`
      );
    } else if (order.productType === "ONLINE_PAYMENT" && order.productId) {
      navigate(
        `/checkout?productId=${order.productId}&courseName=${order.productName}&price=${order.amount}&productType=ONLINE_PAYMENT`
      );
    } else {
      navigate(getBackPath());
    }
  };

  if (!orderId) {
    return (
      <PageWrapper>
        <StatusMessage
          title="Invalid Request"
          bg="bg-yellow-50"
          textColor="text-yellow-700"
          message="Missing order reference. Please check your payment email or try again."
          buttonText="Back"
          buttonPath={getBackPath()}
        />
      </PageWrapper>
    );
  }

  if (isLoading) {
    return (
      <PageWrapper>
        <div className="flex flex-col justify-center items-center py-20">
          <Loader2 className="h-10 w-10 animate-spin text-blue-600" />
          <span className="mt-4 text-lg text-blue-700">Fetching order details...</span>
        </div>
      </PageWrapper>
    );
  }

  if (isError || !order) {
    return (
      <PageWrapper>
        <StatusMessage
          title="Error"
          bg="bg-red-50"
          textColor="text-red-700"
          message="Could not fetch your order details. Please contact support."
          buttonText="Back"
          buttonPath={getBackPath()}
        />
      </PageWrapper>
    );
  }

  switch (status) {
    case "SUCCESS":
      return (
        <PageWrapper>
          <StatusCard
            title={
              order.productType === "COURSE"
                ? "Enrollment Successful!"
                : "Payment Successful!"
            }
            bg="bg-green-50"
            textColor="text-green-700"
            amountLabel="Amount Paid"
            buttonColor="bg-green-600"
            order={order}
            backPath={getBackPath()}
          />
        </PageWrapper>
      );
    case "PENDING":
      return (
        <PageWrapper>
          <StatusCard
            title="Payment Pending"
            bg="bg-yellow-50"
            textColor="text-yellow-700"
            amountLabel="Amount"
            buttonColor="bg-yellow-600"
            order={order}
            pending={true}
            backPath={getBackPath()}
          />
        </PageWrapper>
      );
    case "FAILED":
    default:
      return (
        <PageWrapper>
          <StatusCard
            title="Payment Failed"
            bg="bg-red-50"
            textColor="text-red-700"
            amountLabel="Amount Attempted"
            buttonColor="bg-red-600"
            order={order}
            retryPayment={retryPayment}
            backPath={getBackPath()}
          />
        </PageWrapper>
      );
  }
};

// Wrapper
const PageWrapper = ({ children }) => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 py-10">
    {children}
  </div>
);

// Status Card
const StatusCard = ({
  title,
  bg,
  textColor,
  amountLabel,
  buttonColor,
  order,
  retryPayment,
  pending,
  backPath,
}) => (
  <div
    className={`w-full max-w-lg mx-auto p-8 rounded-2xl shadow-lg border ${bg}`}
    aria-live="polite"
  >
    <h1 className={`text-3xl font-bold mb-4 text-center ${textColor}`}>{title}</h1>
    <p className={`text-md mb-6 text-center ${textColor}`}>
      {pending
        ? "Your payment is in progress. We are checking every few seconds..."
        : order.productType === "COURSE"
        ? "You have been enrolled in the course."
        : "Thank you. Your payment has been processed."}
    </p>

    <div className={`text-left ${textColor} mb-6 space-y-2`}>
      <p>
        <strong>{order.productType === "COURSE" ? "Course" : "Product"}:</strong>{" "}
        {order.productName || "Unknown"}
      </p>
      <p>
        <strong>{amountLabel}:</strong> ₹{order.amount?.toFixed(2)}
      </p>
      <p>
        <strong>{order.transactionId ? "Transaction ID" : "Order ID"}:</strong>{" "}
        {order.transactionId || order.id}
      </p>
    </div>

    <div className="flex justify-center">
      {retryPayment ? (
        <button
          onClick={retryPayment}
          className={`px-6 py-3 rounded-lg text-white font-medium hover:opacity-90 transition ${buttonColor}`}
        >
          Retry Payment
        </button>
      ) : (
        <Link
          to={backPath}
          className={`inline-block px-6 py-3 rounded-lg text-white font-medium hover:opacity-90 transition ${buttonColor}`}
        >
          Back
        </Link>
      )}
    </div>
  </div>
);

// Status Message
const StatusMessage = ({ title, bg, textColor, message, buttonText, buttonPath }) => (
  <div className={`w-full max-w-lg mx-auto p-8 rounded-2xl shadow-lg border ${bg}`}>
    <h1 className={`text-2xl font-bold mb-4 text-center ${textColor}`}>{title}</h1>
    <p className={`text-md ${textColor} mb-6 text-center`}>{message}</p>
    <div className="flex justify-center">
      <Link
        to={buttonPath}
        className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition"
      >
        {buttonText}
      </Link>
    </div>
  </div>
);

export default PaymentStatus;
